<template>
  <div id="app">
    <Toast />
    <BaglantiKesintisi />
    <YeniSurumUyarisi />
    <!-- Yalnız "boot" gecisinde (ilk yukleme / giristen hemen sonra) tam ekran gosterilir -
         o an ekranda AdminLayout yok, arkada gosterilecek bir kabuk yok. Oturum ici sayfa
         gecisleri artik AdminLayout'un kendi ince ust cubugunu kullaniyor (NavProgressBar,
         bkz. AdminLayout.vue) - navbar ve Sparqon boylece hic kapanmiyor. -->
    <LoadingScreen
      v-if="ui.bootLoading"
      title="Yükleniyor"
      subtitle="Lütfen bekleyin"
      message="Sayfa hazırlanıyor..."
    />
    <router-view />
  </div>
</template>

<script>
import { uiState } from './services/uiState';

export default {
  name: 'App',
  data() {
    return {
      ui: uiState,
    }
  },
  mounted() {
    
  },
  methods: {
  
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

#app {
  font-family: "Inter", system-ui, sans-serif;
  height: 100%;
  width: 100%;
}
</style>
